// Complete Text config to use to render text assets in a specific page

const pageTextConfig = {

    GigDetailsRightSection : {
        seePriceTableText: "See Price Bands",
        proceedBtnText: "Proceed to Chat" ,
        addToFavouritesBtnText: "Add To Favourites",
        addedToFavouritesBtnText: "Added To Favourites"
    },

    descriptionSection: {
        descriptionTitle: "About This Gig",
    },

    priceTableSection: {
        priceTableTitle: "Price Bands",
        priceTableDescription: "These are the estimated prices based on the complexity of the project and the time required to complete it. For actual prices, please proceed to next step.",
        priceRangeColTitle: "Price Range",
        deliveryTimeColTitle: "Estimated Delivery",
        descriptionColTitle: "Description"
    },


}

export default pageTextConfig
